import { gql, useQuery } from '@nerdwallet/apollo';
import { ArticleDetails } from './types';
import useTablePress from './use-tablepress';

interface UseArticlesProps {
  useArticlesData: boolean;
  tablePressId: number;
}

export const GET_ARTICLES_DATA_QUERY = gql`
  query breakingNews($articleIds: IdFilterInput) {
    articles(filter: { ids: $articleIds }) {
      items {
        ...ArticleDetails
      }
    }
  }

  fragment ArticleDetails on Article {
    id
    link
    title
    timeToRead {
      minutes
      seconds
    }
    date
    authors {
      name
      link
      avatarUrls(sizes: [SIZE_48]) {
        url
      }
    }
    featuredMedia {
      sourceUrl
      mediaDetails {
        height
        width
        srcSet
      }
    }
  }
`;

const useArticles = ({ useArticlesData, tablePressId }: UseArticlesProps) => {
  const { data: articleIDs, error: tablePressError } = useTablePress({
    useArticlesData,
    tablePressId,
  });

  const { data, loading, error } = useQuery<ArticleDetails>(
    GET_ARTICLES_DATA_QUERY,
    {
      variables: {
        articleIds: { include: articleIDs },
      },
      fetchPolicy: 'no-cache',
      skip: !useArticlesData || !!tablePressError,
    }
  );

  // Normalise the data for the component tree
  const articles = data?.articles?.items ?? [];

  if (error) {
    console.error('Error executing articles data query', error);
  }

  return { articles, isReady: !loading && !error && articles.length > 0 };
};

export default useArticles;
